export default __webpack_public_path__ + "static/media/st2oon.eba78cfc.jpg";